(() => {
  // Fallback only: modern browsers run the parallax as a CSS scroll-driven
  // animation (see section-main-article.scss) — compositor-thread, no jitter.
  // Keep speed/scale/breakpoint in sync with the @keyframes there.
  if (CSS.supports("animation-timeline: view()")) return;

  const PARALLAX_SPEED = 0.45;
  const PARALLAX_SCALE = 1.12;

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  // Parallax is desktop-only — on mobile the image stays static
  const desktopMq = window.matchMedia("(min-width: 990px)");

  const initParallax = (section) => {
    if (!section || section.dataset.parallaxInit === "true") return;

    const heroContainer = section.querySelector(
      ".article-template-header--overlay .article-template-header-container"
    );

    if (!heroContainer || heroContainer.dataset.enableAnimation !== "true") {
      return;
    }

    const heroImage = section.querySelector(
      ".article-template-header--overlay .article-template-header-image--overlay"
    );

    if (!heroImage || reducedMotion.matches) return;

    section.dataset.parallaxInit = "true";

    let ticking = false;
    let inView = true;

    const update = () => {
      // Clamp: iOS rubber-band gives negative scrollY, which flips the shift direction
      const shift = Math.max(window.scrollY, 0) * PARALLAX_SPEED;
      heroImage.style.transform = `translate3d(0, ${shift}px, 0) scale(${PARALLAX_SCALE})`;
      ticking = false;
    };

    const onScroll = () => {
      if (ticking || !inView || !desktopMq.matches) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    // Don't touch the transform while the hero is scrolled out of view
    const observer = new IntersectionObserver(([entry]) => {
      inView = entry.isIntersecting;
      if (inView) onScroll();
    });
    observer.observe(heroContainer);

    desktopMq.addEventListener("change", (event) => {
      if (event.matches) {
        onScroll();
      } else {
        heroImage.style.transform = "";
      }
    });

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  };

  document.querySelectorAll(".section-main-article").forEach(initParallax);

  document.addEventListener("shopify:section:load", (event) => {
    if (event.target?.classList?.contains("section-main-article")) {
      initParallax(event.target);
    }
  });
})();
